import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserController } from '@hub/generated/services';
import { AuthService } from '@hub/services/AuthService';
import { catchError } from 'rxjs/operators';

@Component({
  selector: "userlogin",
  templateUrl: "./userlogin.component.html"
})
export class UserLoginComponent {
  // View properties
  public userName: string;
  public password: string;
  public loginDisabled: boolean = false;
  public loginError: string;

  // Constructors
  constructor(
    private auth: AuthService,
    private router: Router,
    private userController: UserController) {
  }

  // Public Methods
  public login(): void {
    this.loginDisabled = true;
    this.auth.login();
    this.userController.TestUserLogin()
      .pipe(
        catchError(error => {
          this.loginError = "Login failed";
          this.loginDisabled = false;
          throw error;
        })
      )
      .subscribe(() =>  {
        this.loginError = null;
        this.router.navigateByUrl('/')
      });
  }
}
